<template>
  <div
    class="consoleCom subsystemCommon mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftMenuBox">
      <TreeMenu @getActiveItem="getActiveItem" :pageName="'照明系统'" />
    </div>
    <ControlCom ref="endControlCom" :treeActive="treeActive" />
  </div>
</template>

<script>
import { judgeAuthority } from "@/assets/js/utils";
import TreeMenu from "@/components/zixitong/TreeMenu";
import ControlCom from "@/components/zixitong/ControlCom.vue";
export default {
  components: {
    TreeMenu,
    ControlCom,
  },
  data() {
    return {
      listData: [],
      treeActive: {},
      tableList: [],
    };
  },

  methods: {
    judgeAuthority,
    getActiveItem(data) {
      if (!data.id) {
        return;
      }
      this.treeActive = Object.assign({}, data, {
        systemName: "照明设备",
      });
      this.$nextTick(() => {
        this.$refs.endControlCom.handleData();
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
